import { createContext, useContext, useState, FC, ReactNode } from "react";

import {
  IUpdatePasswordProfile,
  IContextProfileContext,
  IUpdateEmailProfile,
  IUpdateProfile,
  IEditPerfil,
  IUpdatePasswordUser,
} from "./ContextProfileTypes";
import { valuesDefaultUpdatePasswordProfile } from "./ValuesDefaultContextProfile/ValuesDefaultContextProfile";

const ContextProfileProvider = createContext({} as IContextProfileContext);

const ContextProfileProviderContext: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [valuesEditPerfil, setValuesEditPerfil] = useState<IEditPerfil>({
    nome: "",
    telefone_1: "",
  });

  const [valuesUpdateEmailProfile, setValuesUpdateEmailProfile] =
    useState<IUpdateEmailProfile>({ email: "" });

  const [valuesUpdatePasswordProfile, setValuesUpdatePasswordProfile] =
    useState<IUpdatePasswordProfile>(valuesDefaultUpdatePasswordProfile);

  const [valuesUpdateProfile, setValuesUpdateProfile] =
    useState<IUpdateProfile>({
      email: "",
      name: "",
      phone1: "",
    });

  const [valuesUpdatePasswordUser, setValuesUpdatePasswordUser] =
    useState<IUpdatePasswordUser>({
      passwordCurrency: "",
      passwordNew: "",
      newPasswordRepeat: "",
    });

  return (
    <ContextProfileProvider.Provider
      value={{
        setValuesUpdatePasswordProfile,
        valuesUpdatePasswordProfile,
        setValuesUpdateEmailProfile,
        setValuesUpdatePasswordUser,
        valuesUpdateEmailProfile,
        valuesUpdatePasswordUser,
        setValuesUpdateProfile,
        setValuesEditPerfil,
        valuesUpdateProfile,
        valuesEditPerfil,
      }}
    >
      {children}
    </ContextProfileProvider.Provider>
  );
};

const useContextProfileContext = (): IContextProfileContext =>
  useContext(ContextProfileProvider);

export { useContextProfileContext, ContextProfileProviderContext };
